import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import React from 'react';
import { Loader } from '../shared/components/ui/Loader/Loader';
import ProtectedRoute from './protectedRoute';
import { Layout } from '../shared/components/layout';

const pages = {
  LoginPage: React.lazy(() => import('../features/auth/components/Login/LoginPage').then(m => ({ default: m.LoginPage }))),
  AddTeacher: React.lazy(() => import('../pages/AddTeacher/AddTeacher').then(m => ({ default: m.AddTeacher }))),
  AddTeacherToCourse: React.lazy(() => import('../pages/AddTeacherToCourse/AddTeacherToCourse').then(m => ({ default: m.AddTeacherToCourse }))),
  AddImagePage: React.lazy(() => import("../pages/AddImage/AddImage").then(m => ({ default: m.AddImage }))),
  // AddPricePage: React.lazy(() => import("../pages/AddPrice/AddPrice").then(m => ({ default: m.AddPrice }))),
  // AddSchedulePage: React.lazy(() => import("../pages/AddSchedule/AddSchedule").then(m => ({ default: m.AddSchedule }))),
  // AddBenefitPage: React.lazy(() => import("../pages/AddBenefit/AddBenefit").then(m => ({ default: m.AddBenefit }))),
  // AddProgramPage: React.lazy(() => import("../pages/AddProgram/AddProgramm").then(m => ({ default: m.AddProgram }))),
  // AddTargetAudiencePage: React.lazy(() => import("../pages/AddTargetAudience/AddTargetAudience").then(m => ({ default: m.AddTargetAudience }))),
  AboutUsPage: React.lazy(() => import('../pages/AboutUs/AboutUs').then(m => ({ default: m.AboutUs }))),
  CoursesPage: React.lazy(() => import('../pages/Courses/Courses').then(m => ({ default: m.Courses }))),
  RegistredUsersPage: React.lazy(() => import('../pages/RegisteredUsers/RegisteredUsers').then(m => ({ default: m.RegisteredUsers }))),
  CourseDetailPage: React.lazy(() => import('../pages/CourseDetail/CourseDetail').then(m => ({ default: m.CourseDetail }))),
  ServicesSciencePage: React.lazy(() => import('../pages/ServicesScience/ServicesScience').then(m => ({ default: m.ServicesScience }))),
  ContactsPage: React.lazy(() => import('../pages/Contacts/Contacts').then(m => ({ default: m.Contacts }))),
  AllTeachersPage: React.lazy(() => import('../pages/AllTeachers/AllTeachers').then(m => ({ default: m.AllTeachers }))),
  PrivacyPolicyPage: React.lazy(() => import('../pages/PrivacyPolicy/PrivacyPolicy').then(m => ({ default: m.PrivacyPolicy }))),
  PublicOfferPage: React.lazy(() => import('../pages/PublicOfferAgreement/PublicOfferAgreement').then(m => ({ default: m.PublicOfferAgreement }))),
  StudyFormatPage: React.lazy(() => import('../pages/StudyFormat/StudyFormat').then(m => ({ default: m.StudyFormat }))),
  UserRulesPage: React.lazy(() => import('../pages/UserRules/UserRules').then(m => ({ default: m.UserRules }))),
  // CreateCoursePage: React.lazy(() => import('../pages/CreateCourse/CreateCourse').then(m => ({ default: m.CreateCourse }))),
  EditCoursePage: React.lazy(() => import('../pages/EditCourse/EditCourse').then(m => ({ default: m.EditCourse }))),
  EditOneCoursePage: React.lazy(() => import('../pages/EditCourse/EditOneCourse').then(m => ({ default: m.EditOneCourse }))),
  EditTeacherPage: React.lazy(() => import('../pages/EditTeacher/EditTeacher').then(m => ({ default: m.EditTeacher }))),
  AdminPanel: React.lazy(() => import('../pages/AdminPanel/AdminPanel').then(m => ({ default: m.AdminPanel }))),
  EntranceCourses: React.lazy(() => import('../pages/Courses/Courses').then(m => ({ default: m.Courses }))),
  QualificationCourses: React.lazy(() => import('../pages/Courses/Courses').then(m => ({ default: m.Courses }))),
  TeacherPage: React.lazy(() => import('../pages/TeacherPage/TeacherPage').then(m => ({ default: m.TeacherPage }))),
  AllTeacherPage: React.lazy(() => import('../pages/AllTeachersPage/AllTeachersPage').then(m => ({ default: m.AllTeachersPage })))
};

const publicRoutes = [
  { path: '/aboutUs', element: <pages.AboutUsPage /> },
  { path: '/courses', element: <pages.CoursesPage /> },
  { path: '/courses/:id', element: <pages.CourseDetailPage /> },
  { path: '/services', element: <pages.ServicesSciencePage /> },
  { path: '/contacts', element: <pages.ContactsPage /> },
  { path: '/login', element: <pages.LoginPage /> },
  { path: '/allTeachers', element: <pages.AllTeachersPage /> },
  { path: '/privacyPolicy', element: <pages.PrivacyPolicyPage /> },
  { path: '/publicOfferAgreement', element: <pages.PublicOfferPage /> },
  { path: '/studyFormat', element: <pages.StudyFormatPage /> },
  { path: '/userRules', element: <pages.UserRulesPage /> },
  { path: '/entranceCourses', element: <pages.EntranceCourses /> },
  { path: '/entranceCourses/:id', element: <pages.CourseDetailPage /> },
  { path: '/qualificationCourses', element: <pages.QualificationCourses /> },
  { path: '/qualificationCourses/:id', element: <pages.CourseDetailPage /> },
  { path: '/teacher/:id', element: <pages.TeacherPage /> },
  { path: '/allTeachersPage', element: <pages.AllTeacherPage /> }
];

const protectedRoutes = [
  // { path: '/createCourse', element: <pages.CreateCoursePage /> },
  { path: '/registeredUsers', element: <pages.RegistredUsersPage /> },
  { path: '/editCourse', element: <pages.EditCoursePage /> },
  { path: '/editCourse/:id', element: <pages.EditOneCoursePage /> },
  { path: '/editTeacher/:id', element: <pages.EditTeacherPage /> },
  { path: '/addImage', element: <pages.AddImagePage /> },
  { path: '/addTeacher', element: <pages.AddTeacher /> },
  { path: '/addTeacherToCourse', element: <pages.AddTeacherToCourse /> },
  // { path: '/addPrice', element: <pages.AddPricePage /> },
  // { path: '/addSchedule', element: <pages.AddSchedulePage /> },
  // { path: '/addBenefit', element: <pages.AddBenefitPage /> },
  // { path: '/addProgram', element: <pages.AddProgramPage /> },
  // { path: '/addTargetAudience', element: <pages.AddTargetAudiencePage /> },
  { path: '/adminPanel', element: <pages.AdminPanel /> }
];

const renderRoutes = (routes) =>
  routes.map(({ path, element }) => <Route key={path} path={path} element={element} />);

export default function GetRoutes() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
      <Route path="/" element={<Layout />}>
          <Route index element={<pages.AboutUsPage />} />
          
          {renderRoutes(publicRoutes)}
          
          <Route element={<ProtectedRoute />}>
            {renderRoutes(protectedRoutes)}
          </Route>
        </Route>
        
        <Route path="*" element={<Navigate to="/aboutUs" replace />} />
      </Routes>
    </Suspense>
  );
}
